module.exports = __webpack_public_path__ + "assets/home-bg1-de8e2f.jpg";


/*****************
 ** WEBPACK FOOTER
 ** F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/Content/images/home-bg1.jpg
 ** module id = 918
 ** module chunks = 2
 **/